import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ProfileComponent } from './main/configuracao/pages/profile/profile.component';
import { WelcomeComponent as EducacaoComponent } from './main/educacao/pages/welcome/welcome.component';
import { ListComponent as HaoComponent } from './main/hao/pages/list/list.component';
import { MfgComponent } from './main/hao/pages/mfg/mfg.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { UnderMaintenanceComponent } from './pages/under-maintenance/under-maintenance.component';
import { ListComponent as HeadhunterListComponent } from './main/headhunter/pages/list/list.component';
import { ListHaoComponent } from './main/favorite/pages/list-hao/list-hao.component';
import { ListPhhComponent } from './main/favorite/pages/list-phh/list-phh.component';
import { WebAdminComponent } from './main/web-admin/web-admin.component';
import { LoginComponent } from './main/metrics/pages/login/login.component';
import {SharedComponent} from "./main/consultor/pages/shared/shared.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'account/login',
    pathMatch: 'full',
  },
  {
    path: 'hao',
    component: HaoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'favorites/hao',
    component: ListHaoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'favorites/phh',
    component: ListPhhComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'mfg',
    component: MfgComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'educacao',
    component: EducacaoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'configuracao',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'web-admin',
    component: WebAdminComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'headhunter',
    component: HeadhunterListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'share',
    component: SharedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadChildren: () => import('../app/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'under-maintenance',
    component: UnderMaintenanceComponent
  },
  {
    path: 'login-metric',
    component: LoginComponent
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
